import { useState, useEffect } from 'react';

// Using placeholder image URLs to ensure compilation in this environment.
import bannerImage1 from '../../assets/M12.png';
import bannerImage2 from '../../assets/M23.png';
import bannerImage3 from '../../assets/M32.png';
import bannerImage4 from '../../assets/M4.png';

const bannerData = [
  {
    image: bannerImage1,
    title: "Momo.com Fast Food & Restaurant",
    description: "Lohia Nagar, Bismil Nagar, Maharajganj, Uttar Pradesh 273303",
    buttonText: null,
    buttonLink: null,
    content: (
     <div className="text-white text-center p-4 flex flex-col items-center h-full">
        <h3 className="text-xl md:text-2xl font-bold mb-2">Our Momo's Menu </h3>
        {/* MODIFIED SECTION STARTS HERE */}
        <div className="flex justify-between items-center text-sm md:text-base font-bold mb-2 px-2 w-full"> {/* Added w-full */}
          <span className="flex-grow text-left"></span> {/* This empty span pushes content to the right */}
          <div className="flex w-32 justify-between">
            <span className="text-right flex-1 pr-4">Half</span>
            <span className="text-right flex-1">Full</span>
          </div>
        </div>
        <ul className="text-sm md:text-base space-y-1">
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">VEG STEAM MOMOS:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">30</span>
              <span className="text-right flex-1">50</span>
            </div>
          </li>
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">PANEER STEAM MOMOS:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">55</span>
              <span className="text-right flex-1">100</span>
            </div>
          </li>
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">VEG FRIED MOMOS:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">40</span>
              <span className="text-right flex-1">70</span>
            </div>
          </li>
          {/* <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">PANEER FRIED MOMOS:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">35</span>
              <span className="text-right flex-1">70</span>
            </div>
          </li> */}
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">PANEER KURKURE MOMOS:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">75</span>
              <span className="text-right flex-1">140</span>
            </div>
          </li>
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Chilli MOMOS:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">---</span>
              <span className="text-right flex-1">70</span>
            </div>
          </li>
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Chilli PANEER MOMOS:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">---</span>
              <span className="text-right flex-1">100</span>
            </div>
          </li>
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Tanduri Malai MOMOS:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">---</span>
              <span className="text-right flex-1">200</span>
            </div>
          </li>
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Tanduri Malai MOMOS:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">---</span>
              <span className="text-right flex-1">170</span>
            </div>
          </li>
        </ul>
      </div>
    ),
  },
  {
    image: bannerImage2,
    title: "Momo.com Fast Food & Restaurant",
    description: "Lohia Nagar, Bismil Nagar, Maharajganj, Uttar Pradesh 273303",
    buttonText: null,
    buttonLink: null,
    content: (
      <div className="text-white text-center p-4 flex flex-col items-center h-full">
        <h3 className="text-xl md:text-2xl font-bold mb-2">Our Roll and Chilli's </h3>
        {/* MODIFIED SECTION STARTS HERE */}
        <div className="flex justify-between items-center text-sm md:text-base font-bold mb-2 px-2 w-full"> {/* Added w-full */}
          <span className="flex-grow text-left"></span> {/* This empty span pushes content to the right */}
          <div className="flex w-32 justify-between">
            {/* <span className="text-right flex-1 pr-4">Half</span> */}
            <span className="text-right flex-1">Full</span>
          </div>
        </div>
        {/* MODIFIED SECTION ENDS HERE */}
        <ul className="text-sm md:text-base space-y-1">
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Cheese Paneer Roll:</span>
            <div className="flex w-32 justify-between">
              {/* <span className="text-right flex-1 pr-4">---</span> */}
              <span className="text-right flex-1">₹70</span>
            </div>
          </li>
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Manchurian:</span>
            <div className="flex w-32 justify-between">
              {/* <span className="text-right flex-1 pr-4">---</span> */}
              <span className="text-right flex-1">₹70</span>
            </div>
          </li>
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Mashroom Chilli:</span>
            <div className="flex w-32 justify-between">
              {/* <span className="text-right flex-1 pr-4">---</span> */}
              <span className="text-right flex-1">₹80</span>
            </div>
          </li>

           <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Paneer Chilli:</span>
            <div className="flex w-32 justify-between">
              {/* <span className="text-right flex-1 pr-4">---</span> */}
              <span className="text-right flex-1">₹100</span>
            </div>
          </li>
          
        </ul>
      </div>
    ),
  },
  {
    image: bannerImage3,
    title: "Momo.com Fast Food & Restaurant",
    description: "Lohia Nagar, Bismil Nagar, Maharajganj, Uttar Pradesh 273303",
    buttonText: null,
    buttonLink: null,
    content: (
      <div className="text-white text-center p-4 flex flex-col items-center h-full">
        <h3 className="text-xl md:text-2xl font-bold mb-2">Our Noodle's &  </h3>
        {/* MODIFIED SECTION STARTS HERE */}
        <div className="flex justify-between items-center text-sm md:text-base font-bold mb-2 px-2 w-full"> {/* Added w-full */}
          <span className="flex-grow text-left"></span> {/* This empty span pushes content to the right */}
          <div className="flex w-32 justify-between">
            <span className="text-right flex-1 pr-4">Half</span>
            <span className="text-right flex-1">Full</span>
          </div>
        </div>
        {/* MODIFIED SECTION ENDS HERE */}
        <ul className="text-sm md:text-base space-y-1">
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Veg Noodles:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">₹55</span>
              <span className="text-right flex-1">₹110</span>
            </div>
          </li>
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Paneer Noodles:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">₹75</span>
              <span className="text-right flex-1">₹140</span>
            </div>
          </li>
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Veg Burger:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">---</span>
              <span className="text-right flex-1">₹40</span>
            </div>
          </li>
           <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Crispy Burger:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">---</span>
              <span className="text-right flex-1">₹80</span>
            </div>
          </li>
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Veg Sandwich:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">---</span>
              <span className="text-right flex-1">₹70</span>
            </div>
          </li>

        </ul>
      </div>
    ),
  },
  {
    image: bannerImage4,
    title: "Momo.com",
    description: "Lohia Nagar, Bismil Nagar, Maharajganj, Uttar Pradesh 273303",
    buttonText: null,
    buttonLink: null,
    content: (
      <div className="text-white text-center p-4 flex flex-col items-center h-full">
        <h3 className="text-xl md:text-2xl font-bold mb-2">Our Fry, Soup & Drink Menu</h3>
        {/* MODIFIED SECTION STARTS HERE */}
        <div className="flex justify-between items-center text-sm md:text-base font-bold mb-2 px-2 w-full"> {/* Added w-full */}
          <span className="flex-grow text-left"></span> {/* This empty span pushes content to the right */}
          <div className="flex w-32 justify-between">
            <span className="text-right flex-1 pr-4">Half</span>
            <span className="text-right flex-1">Full</span>
          </div>
        </div>
        {/* MODIFIED SECTION ENDS HERE */}
        <ul className="text-sm md:text-base space-y-1">
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Veg Fry Rice:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">₹55</span>
              <span className="text-right flex-1">₹110</span>
            </div>
          </li>
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Paneer Fry Rice:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">₹75</span>
              <span className="text-right flex-1">₹140</span>
            </div>
          </li>
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">French Fries:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">---</span>
              <span className="text-right flex-1">₹50</span>
            </div>
          </li>
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Veg Hot & Sour Soup:</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">---</span>
              <span className="text-right flex-1">₹60</span>
            </div>
          </li>
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Veg Manchow Soup :</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">---</span>
              <span className="text-right flex-1">₹60</span>
            </div>
          </li>
           <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Hot Coffe :</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">---</span>
              <span className="text-right flex-1">₹30</span>
            </div>
          </li>
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Blue Majito :</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">---</span>
              <span className="text-right flex-1">₹65</span>
            </div>
          </li>
          <li className="flex justify-between items-center px-2">
            <span className="flex-grow text-left">Mint Majito :</span>
            <div className="flex w-32 justify-between">
              <span className="text-right flex-1 pr-4">---</span>
              <span className="text-right flex-1">₹65</span>
            </div>
          </li>
        </ul>
      </div>
    ),
  }
];

const Menu = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [direction, setDirection] = useState('next');
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Determine if on the first or last banner
  const isOnFirstBanner = currentImageIndex === 0;
  const isOnLastBanner = currentImageIndex === bannerData.length - 1;

  useEffect(() => {
    let interval;
    // Only set up interval if not on the last banner
    if (!isOnLastBanner) {
      interval = setInterval(() => {
        handleNext();
      }, 1000); // Changed to 1 second for quicker testing, adjust back to 30000 (30 seconds) if needed
    }

    return () => clearInterval(interval);
  }, [currentImageIndex, isOnLastBanner]);

  const handlePrev = () => {
    // Disable if transitioning or if already on the first banner
    if (isTransitioning || isOnFirstBanner) return;
    setDirection('prev');
    setIsTransitioning(true);
    setCurrentImageIndex((prevIndex) => prevIndex - 1); // Simple decrement
  };

  const handleNext = () => {
    // Disable if transitioning or if already on the last banner
    if (isTransitioning || isOnLastBanner) return;
    setDirection('next');
    setIsTransitioning(true);
    setCurrentImageIndex((prevIndex) => prevIndex + 1); // Simple increment
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 font-sans">
      <section
        id="Menu"
        className="mt-px scroll-mt-20 w-full max-w-8xl"
      ><br />
        <div className="flex flex-col items-center gap-8">

          <div
            className="relative overflow-hidden w-full max-w-lg rounded-lg " // Changed max-w-lg to max-w-full
            style={{ minHeight: '600px', height: 'fit-content' }}
          >
            {bannerData.map((banner, index) => {
              let transformClass = '';

              if (index === currentImageIndex) {
                transformClass = 'translate-x-0';
              } else if (direction === 'next') {
                transformClass = index < currentImageIndex ? '-translate-x-full' : 'translate-x-full';
              } else { // direction === 'prev'
                transformClass = index > currentImageIndex ? 'translate-x-full' : '-translate-x-full';
              }

              return (
                <div
                  key={index}
                  className={`absolute top-0 left-0 w-full h-full
                    ${isTransitioning ? 'transition-transform duration-1000 ease-in-out' : 'transition-none'}
                    ${transformClass}`}
                  onTransitionEnd={() => setIsTransitioning(false)}
                >
                  <img
                    src={banner.image}
                    alt={`Momo.com Fast Food & Restaurant Banner ${index + 1}`}
                    className="w-full h-full object-cover block"
                  />
                  <div className="absolute inset-0 flex flex-col items-center justify-center p-4 bg-black bg-opacity-50">
                    {banner.content ? (
                      banner.content
                    ) : (
                      <>
                        {/* Title and description removed as per user's content structure */}
                      </>
                    )}
                  </div>
                </div>
              );
            })}

            <button
              onClick={handlePrev}
              disabled={isOnFirstBanner} // Disable if on the first banner
              className={`absolute left-0 top-1/2 -translate-y-1/2 p-2 md:p-4 bg-black bg-opacity-20 hover:bg-opacity-40 text-white text-2xl md:text-4xl rounded-full transition-all duration-300 z-10 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity50
                ${isOnFirstBanner ? 'opacity-50 cursor-not-allowed' : ''}`}
              aria-label="Previous slide"
            >
              &#10094;
            </button>

            <button
              onClick={handleNext}
              disabled={isOnLastBanner} // Disable if on the last banner
              className={`absolute right-0 top-1/2 -translate-y-1/2 p-2 md:p-4 bg-black bg-opacity-20 hover:bg-opacity-40 text-white text-2xl md:text-4xl rounded-full transition-all duration-300 z-10 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50
                ${isOnLastBanner ? 'opacity-50 cursor-not-allowed' : ''}`}
              aria-label="Next slide"
            >
              &#10095;
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Menu;